module.exports = {
    REACT_APP_API_KEY: "AIzaSyAmmvl41kvDwGTFdVeghqTq7QDqEPy7CvM",
    REACT_APP_AUTH_DOMAIN: "my-website-e3c2d.firebaseapp.com",
    REACT_APP_DATABASE_URL: "https://my-website-e3c2d.firebaseio.com",
    REACT_APP_PROJECT_ID: "my-website-e3c2d",
    REACT_APP_STORAGE_BUCKET: "my-website-e3c2d.appspot.com",
    REACT_APP_MESSAGING_SENDER_ID: 864703697214,
    REACT_APP_APP_ID: "1:864703697214:web:66139de500aa3a7c8c5c6f",
    REACT_APP_MEASUREMENT_ID: "G-1326LQ1639"
};